import { useTranslation } from 'react-i18next';
import { useSettings } from '@connect-x-app/hybrid-state';
import { Text } from '@connect-x-app/hybrid-ui';
import { PushNotificationGroup } from '@connect-x-app/shared-domain-models';
import { Spinner } from '@connect-x-app/web-ui';

import { PushNotificationGroupDetail } from './components/pushNotificationGroupDetail';
import { PushNotificationGroups } from './components/pushNotificationGroups';

import './Settings.scss';

type Props = {
  group: PushNotificationGroup | null;
  onSelectGroup: (group: PushNotificationGroup | null) => void;
};

export const Settings = ({ group, onSelectGroup }: Props) => {
  const { t } = useTranslation();

  const { isError, isLoading, isUpdating, onToggleAllPushNotifications, onUpdatePushNotificationSetting, settings } =
    useSettings();

  if (isLoading) {
    return (
      <div className="loading-indicator">
        <Spinner size="large" />
      </div>
    );
  }

  if (isError) {
    return <Text size="MD">{t('ERRORS.GENERAL')}</Text>;
  }

  const pushNotifications = settings?.pushNotifications ?? [];

  return (
    <>
      <Text className="settings-section-title" size="SM" weight="bold">
        {group ? t(`SETTINGS.PUSH_NOTIFICATION_GROUP.${group}`) : t('SETTINGS.PUSH_NOTIFICATIONS')}
      </Text>
      {group ? (
        <PushNotificationGroupDetail
          group={group}
          isUpdating={isUpdating}
          onToggleAllPushNotifications={onToggleAllPushNotifications}
          onUpdatePushNotificationSetting={onUpdatePushNotificationSetting}
          pushNotifications={pushNotifications}
        />
      ) : (
        <PushNotificationGroups onSelectGroup={onSelectGroup} pushNotifications={pushNotifications} />
      )}
    </>
  );
};
